import { Box } from "@mui/material";
import { useLocation, useParams } from 'react-router-dom';
import { useGetNotification } from "../../../../logic/useApiQuery";
import { AccountVerificationForm } from "./AccountVerificationForm";
import { AccountVerificationTaskStatusIndicator } from "./AccountVerificationTaskStatusIndicator";
import { PlaidComponent } from "./PlaidComponent";

export function AccountVerificationTask() {
  const { search } = useLocation()
  const { closingId, id } = useParams()

  const { data: notification } = useGetNotification(closingId ?? '', id ?? '', search ?? '')

  return (
    <AccountVerificationTaskStatusIndicator>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {!notification?.IsPlaidOffered && <AccountVerificationForm />}
        {notification?.IsPlaidOffered && <PlaidComponent />}
      </Box>
    </AccountVerificationTaskStatusIndicator>
  )
}
